import type { ParentChild } from "../../types/parentFamily";
import {
  mapFamilyMemberFromApi,
  normalizeSchoolFees,
} from "../../utils/familyApiMappers";
import { api } from "../../services/api";

export function familyQueryKey(orgId: string, userId: string) {
  return ["family", orgId, userId] as const;
}

export async function loadFamilyMembers(
  orgId: string,
  userId: string,
  token: string
): Promise<ParentChild[]> {
  const members = await api.family.getForUser(orgId, userId, token);

  return members.map((member) => {
    const mapped = mapFamilyMemberFromApi(member);
    return {
      ...mapped,
      schoolFees: normalizeSchoolFees(mapped.schoolFees),
    };
  });
}
